import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  DELETE_CONTACT_REQUEST,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAILURE,
  GET_ALL_DATA_LOCATIONS_DEFAULT_SUCCESS,
  GET_ALL_IMPC_LOCATIONS_DEFAULT_SUCCESS,
  CHECK_EMAIL_ADDRESS_SUCCESS,
  GET_CONTACT_DETAILS_REQUEST,
  GET_CONTACT_DETAILS_SUCCESS,
  GET_CONTACT_DETAILS_FAILURE,
  ADD_NEW_CONTACT_REQUEST,
  ADD_NEW_CONTACT_SUCCESS,
  ADD_NEW_CONTACT_FAILURE,
  EDIT_CONTACT_REQUEST,
  SET_CONTACT_GROUP,
  COPY_CONTACTS_REQUEST,
  CLEAR_EMAIL_DUPLICATE,
} from '../actions/types/ContactsActionTypes';
import {
  ASSOCIATE_CONTACTS_REQUEST,
  ASSOCIATE_CONTACTS_SUCCESS,
  ASSOCIATE_CONTACTS_FAILURE,
} from '../../../device-information/contact-management/redux/actions/types/ContactManagementActionTypes';

export const initialState = {
  deleteContactRequestLoading: false,
  dataLocationList: [],
  impcLocationList: [],
  isEmailAddressDuplicate: false,
  associateContactRequestLoading: false,
  createContactRequestLoading: false,
  isContactDetailLoading: false,
  contactDetail: null,
  selectedContactGroup: null,
  selectedIMPC: null,
};

const ContactManagementReducer = (state = initialState, action) => {
  switch (action.type) {
  case DELETE_CONTACT_REQUEST:
    return {
      ...state,
      deleteContactRequestLoading: true,
      selectedContactGroup: action.payload.contactGroup,
      selectedIMPC: action.payload.impcCode || null,
    };
  case DELETE_CONTACT_SUCCESS:
  case DELETE_CONTACT_FAILURE:
    return {
      ...state,
      deleteContactRequestLoading: false,
    };
  case GET_ALL_DATA_LOCATIONS_DEFAULT_SUCCESS:
    return {
      ...state,
      dataLocationList: action.payload,
    };
  case GET_ALL_IMPC_LOCATIONS_DEFAULT_SUCCESS:
    return {
      ...state,
      impcLocationList: action.payload,
    };
  case CHECK_EMAIL_ADDRESS_SUCCESS:
    return {
      ...state,
      isEmailAddressDuplicate: action.payload,
    };
  case ASSOCIATE_CONTACTS_REQUEST:
    return {
      ...state,
      associateContactRequestLoading: true,
    };
  case ASSOCIATE_CONTACTS_SUCCESS:
    return {
      ...state,
      associateContactRequestLoading: false,
    };
  case ASSOCIATE_CONTACTS_FAILURE:
    return {
      ...state,
      associateContactRequestLoading: false,
    };
  case ADD_NEW_CONTACT_REQUEST:
    return {
      ...state,
      createContactRequestLoading: true,
      selectedContactGroup: action.payload.contactGroup,
      selectedIMPC: action.payload.impcCode || null,
    };
  case ADD_NEW_CONTACT_SUCCESS:
    return {
      ...state,
      createContactRequestLoading: false,
    };
  case ADD_NEW_CONTACT_FAILURE:
    return {
      ...state,
      createContactRequestLoading: false,
    };
  case GET_CONTACT_DETAILS_REQUEST:
    return {
      ...state,
      isContactDetailLoading: true,
      contactDetail: null,
    };
  case GET_CONTACT_DETAILS_SUCCESS:
    return {
      ...state,
      isContactDetailLoading: false,
      contactDetail: action.payload,
    };
  case GET_CONTACT_DETAILS_FAILURE:
    return {
      ...state,
      isContactDetailLoading: false,
    };
  case EDIT_CONTACT_REQUEST: {
    return {
      ...state,
      selectedContactGroup: action.payload.contactGroup,
      selectedIMPC: action.payload.impcCode || null,
    };
  }
  case SET_CONTACT_GROUP: {
    return {
      ...state,
      selectedContactGroup: action.contactGroup,
    };
  }
  case COPY_CONTACTS_REQUEST: {
    return {
      ...state,
      selectedContactGroup: 'MRD',
      selectedIMPC: action.payload.targetImpcCode,
    };
  }
  case CLEAR_EMAIL_DUPLICATE: {
    return {
      ...state,
      isEmailAddressDuplicate: false,
      contactDetail: null,
    };
  }
  case AUTH_LOGOUT:
    return initialState;

  default:
    return state;
  }
};

export default ContactManagementReducer;
